<template>
  <div class="wrapper">
    <div id="app">
      <svgIcons></svgIcons>
    <!-- <label v-if="this.$route.name!='Home'" class="verticalLabel left moduleTitle"></label> -->
    <!-- <label v-if="this.$route.name!='Home'" class="verticalLabel right reportTitle">{{$t('report.title')}}</label> -->
      <vue-page-transition name="overlay-right">
        <router-view />   
      </vue-page-transition>
      <!-- <Template></Template> -->
      <!-- <at-glance></at-glance> -->
      <!-- <Home></Home> -->
      <!-- <Footer></Footer> -->
    </div>
  </div>
</template>

<script>
import Header from "@/common/layout/header.vue";

import svgIcons from "@/common/svgIcons.vue";
export default {

  components: {
    Header,
    svgIcons
  },
  created: function(){
    if (this.$i18n.locale == 'ar') {
        document.getElementsByTagName('html')[0].lang = 'ar'
        document.getElementsByTagName('html')[0].classList.add('ar')
    }
    
  },
    watch: {
        $route() {
            document.documentElement.removeAttribute("data-page");
            document.body.classList.remove("no-scroll");
            document.body.classList.remove("menuOpen");
            document.body.classList.remove("no-overFlow");
            document.body.classList.remove("light-Slide");
            document.documentElement.classList.remove("menuOpen");
            document.documentElement.setAttribute("data-page", this.$route.name);
        }
    },
};
</script>
<style>
@keyframes fadeInRight {
  from {
    transform: translate3d(20%, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.overlay-right-enter{
    opacity: 0;
    transition: all 0.5s ease;
}
.fade-in-right-leave-to {
  opacity: 0;
  transition: all 0.5s ease;
  transform: translate3d(-20%, 0, 0);
}

.fade-in-right-enter {
  opacity: 0;
  transform: translate3d(20%, 0, 0);
}

.fade-in-right-enter-to {
  opacity: 0;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-name: fadeInRight;
}

@keyframes fadeInDown {
  from {
    transform: translate3d(0, -40px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fade-in-down-leave-to {
  opacity: 0;
  transition: opacity 0.3s;
}

.fade-in-down-enter {
  opacity: 0;
  transform: translate3d(0, -40px, 0);
}

.fade-in-down-enter-to {
  opacity: 0;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
}
</style>
<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
